module.exports = __webpack_public_path__ + "static/iys-image-8576af1b46675faa18ab2f559b8f9b02.svg";